// apps/web/src/pages/Login.tsx
import * as React from 'react';
import AuthPanel from '../components/AuthPanel';

export default function LoginPage() {
  return (
    <div className="min-h-dvh grid place-items-center px-4">
      <AuthPanel />
    </div>
  );
}
